import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="bg-navy-deep py-12 text-ivory-light sm:py-16" aria-labelledby="final-title" data-id="element-58" data-mp="vghfvkydo5mw">
      <div className="mx-auto max-w-2xl px-5 text-center sm:px-8" data-id="element-59" data-mp="19gij37247p5j">
        <h2 id="final-title" className="font-display text-[26px] font-semibold uppercase leading-[1.08] tracking-tightish sm:text-4xl" data-id="element-60" data-mp="15cu80ee9ybfj">
          Stop starting every session from scratch.
        </h2>
        <p className="mx-auto mt-3 max-w-md text-[14.5px] leading-snug text-ivory/75 sm:text-lg" data-id="element-61" data-mp="1edipjj2vmtx6">
          Get one organized professional resource system for pediatric + adult speech therapy
          practice.
        </p>

        <div className="mt-6 flex items-center justify-center gap-2 text-[11.5px] font-semibold uppercase tracking-[0.12em] text-ivory/80 sm:text-sm" data-id="element-62" data-mp="1o5y569qpb6ew">
          <span className="rounded-full border border-ivory/20 px-3 py-1.5" data-id="element-63" data-mp="1x5b96mw232s8">Open</span>
          <ArrowRightIcon className="h-3.5 w-3.5 text-sage" aria-hidden="true" data-id="element-64" data-mp="n6495hoebgir" />
          <span className="rounded-full border border-ivory/20 px-3 py-1.5" data-id="element-65" data-mp="s4p8zfzqjy6o">Choose</span>
          <ArrowRightIcon className="h-3.5 w-3.5 text-sage" aria-hidden="true" data-id="element-66" data-mp="s6iid31qgwid" />
          <span className="rounded-full border border-ivory/20 px-3 py-1.5" data-id="element-67" data-mp="x5v75tc60dnl">Use</span>
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-68" data-mp="120scap6bq2v7">
          <CtaButton variant="gold" tone="dark" microcopy="$27 USD • One-time payment • Instant access" data-id="element-69" data-mp="1658iysnrhebh">
            Get the Clinical Toolkit™
          </CtaButton>
        </div>

        <p className="mt-9 text-[11px] uppercase tracking-[0.12em] text-ivory/35" data-id="element-70" data-mp="1fvl2qinr53gk">
          Speech Therapy Clinical Toolkit™ • ProKit Digital™
        </p>
      </div>
    </section>;
}